module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M12 15.324c2.366-.942 8.286-2.968 16-3.284v10.264A7.151 7.151 0 0 0 26 22c-3.314 0-6 2.238-6 5s2.686 5 6 5 6-2.238 6-5V2c0-1.106-.542-2-2.042-2H30C18.016 0 10.356 3.828 10 4c0 0 .304-.166 0 0-.888.484-2 1.042-2 2.666v15.638A7.151 7.151 0 0 0 6 22c-3.314 0-6 2.238-6 5s2.686 5 6 5 6-2.238 6-5V15.324z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/music-1.js
// module id = 1294
// module chunks = 14